// product-form-new.js
export default (Alpine) => {
    Alpine.data("dynamicBundle", (
        stackParentId,
        stackParentTitle,
        stackDiscountValue,
        stackDiscountType,
        stackParentVariantId
    ) => ({
        stackParentId: Number(stackParentId),
        stackParentTitle: stackParentTitle,
        stackDiscountValue: Number(stackDiscountValue),
        stackDiscountType: stackDiscountType,
        stackParentVariantId: Number(stackParentVariantId),
        bundleObj: window.dynamicBundle,
        currentVariant: null,
	    sellingPlan: null,
	    deliveryOptions: false,
		quantity: 1,
		purchaseOption: 'One-time Purchase',
        totalOriginalPrice: 0,
        totalOtpPrice: 0,
        totalSubPrice: 0,
        stackProducts: [],
        dynamicBox: {},
        dynamicBoxId: '',
        available: true,
        tierDiscount: {
            "1": 0,
            "2": 10,
            "3": 15,
            "4": 20,
            "5": 25,
        },

        get stackDiscount() {
            return this.tierDiscount[this.stackProducts.length];
        },

        get totalDiscount() {
            return this.totalPrice * (1 - this.stackDiscount / 100);
        },

        get totalPrice() {
            return this.stackProducts.reduce((acc, product) => acc + Number(this.bundleObj[product].price), 0);
        },

        async init() {
            const purchaseOptions = this.$el.querySelectorAll('[data-purchase-option]');

            purchaseOptions.forEach(option => {
                const input = option.querySelector('input[type="radio"]');
                input.addEventListener('change', this.purchaseOptionChange.bind(this));
            });

            const frequencyOptions = this.$el.querySelector('.frequencyOptions');
            frequencyOptions.addEventListener('change', this.frequencyChange.bind(this));

            document.addEventListener('add-to-cart', this.addToCart.bind(this));


            Array.from(this.$el.querySelectorAll('[data-option]')).forEach(option => {

                let value = ''

                if (option.querySelector('select')) {
                    value = option.querySelector('select').value;
                } else if (option.querySelector('input[type="hidden"]')) {
                    value = option.querySelector('input[type="hidden"]').value;
                } else {
                    value = 'Sold Out';
                    this.available = false;
                }

                const optionIndex = option.dataset.option;
                this.stackProducts[optionIndex] = value;

            });

            if (this.available) {
                this.updatePrices(false);
            } else {
                this.setButtonDisabled(true);
                this.updatePrices(true);
            }

            await this.fetchDynamicBox();
        },

        setButtonDisabled(disabled) {
            const addToCartButton = this.$el.querySelector('#add-to-cart');
            addToCartButton.disabled = disabled;
            addToCartButton.innerHTML = disabled ? 'Sold Out' : 'Add to cart';
        },

        async fetchDynamicBox() {
            await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*'
                },
                    body: JSON.stringify({
                    productPlatformId: this.stackParentId
                })
            })
                .then(res => res.json())
                .then(data => {
                    this.dynamicBox = data.DynamicBox;
                    this.dynamicBoxId = this.dynamicBox.boxId;
                })
                .catch(err => console.error("Dynamic Box Error:", err));
        },

        changeVariant(productId, event) {
            const index = event.target.closest('[data-option]').dataset.option;
            const selectedIndex = event.target.selectedIndex;

            this.stackProducts[index] = event.target.value;

            this.updatePrices(false);

            const variantImage = event?.target?.querySelector('option[value="' + event.target.value + '"]').dataset.variantImage;
            const variantImageEl = event?.target?.closest('[data-option]').querySelector('[data-variant-image-container]');

            if (!variantImageEl) return;

            if (variantImage) {
                variantImageEl.src = variantImage;
            }

            if (event.target.hasAttribute('data-flavor')) {
                const flavorSelect = event.target;
                flavorSelect.dataset.flavor = event.target.options[selectedIndex].dataset.flavor;
            }

            const productTitle = event.target.closest('[data-option]').querySelector('[data-product-title]');
            productTitle.innerHTML = this.bundleObj[event.target.value].productTitle;
        },

        updatePrices(defaultPrices = false) {
            if (defaultPrices) {
                const originalPrice = this.$el.querySelector('[data-original-price]');
                const subPrice = this.$el.querySelector('[data-sub-price]');
                const otpPrice = this.$el.querySelector('[data-otp-price]');
                this.totalOriginalPrice = originalPrice.innerHTML;
                this.totalOtpPrice = otpPrice.innerHTML;
                this.totalSubPrice = subPrice.innerHTML;
                return;
            }

            let totalPrice = 0;
            let subPrice = 0;
            let newPrice = 0;
            let selectedSellingPlan = null;

            this.stackProducts.forEach(variantId => {
                totalPrice += Number(this.bundleObj[variantId].price);
            });

            totalPrice = totalPrice / 100;

            newPrice = totalPrice * (1 - this.stackDiscount / 100);

            if (this.sellingPlan) {
                selectedSellingPlan = this.sellingPlan;
            } else {
                selectedSellingPlan = Object.keys(window.sellingPlanGroups)[0];
            }

            const subDiscount = window.sellingPlanGroups[selectedSellingPlan].discount_value;
            const subDiscountType = window.sellingPlanGroups[selectedSellingPlan].discount_type;


            if (subDiscountType === 'percentage') {
                subPrice = newPrice * (1 - subDiscount / 100);
            } else {
                subPrice = newPrice - subDiscount;
            }

            this.totalOriginalPrice = this.formatMoney(totalPrice);
            this.totalOtpPrice = this.formatMoney(newPrice);
            this.totalSubPrice = this.formatMoney(subPrice);
        },

        formatMoney(value, fmt = window.Shopify?.money_format || "{{amount}}") {
            const toCents = (v) => {
              if (typeof v === 'number') return Math.round(v * 100);
              if (typeof v === 'string') {
                const cleaned = v.trim().replace(/[,$\s]/g, '');
                const n = Number(cleaned);
                return Number.isFinite(n) ? Math.round(n * 100) : 0;
              }
              return 0;
            };
    
            const cents = toCents(value);
    
            if (window.Shopify?.formatMoney) {
              return window.Shopify.formatMoney(cents, fmt);
            }
    
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            const token = (fmt.match(placeholderRegex) || [, 'amount'])[1];
    
            const withDelims = (n, precision = 2, thousands = ',', decimal = '.') => {
              if (n == null || isNaN(n)) return '0';
              const s = (n / 100).toFixed(precision);
              const [intPart, frac] = s.split('.');
              const intWithSep = intPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
              return precision ? `${intWithSep}${decimal}${frac}` : intWithSep;
            };
    
            let rendered;
            switch (token) {
              case 'amount':
                rendered = withDelims(cents, 2);
                break;
              case 'amount_no_decimals':
                rendered = withDelims(cents, 0);
                break;
              case 'amount_with_comma_separator':
                rendered = withDelims(cents, 2, '.', ',');
                break;
              case 'amount_no_decimals_with_comma_separator':
                rendered = withDelims(cents, 0, '.', ',');
                break;
              default:
                rendered = withDelims(cents, 2);
            }
    
            return fmt.replace(placeholderRegex, rendered);
        },

        purchaseOptionChange(e) {
            const freqSelector = this.$el.querySelector('select[name="frequency"]');
            if (e.target.value === 'Subscribe & Save') {
                this.sellingPlan = freqSelector.value;
                this.toggleDeliveryOptions();
                this.purchaseOption = 'Subscribe & Save';
            } else {
                this.sellingPlan = null;
                this.toggleDeliveryOptions();
                this.purchaseOption = 'One-time Purchase';
            }
        },

        toggleDeliveryOptions() {
                const deliveryOptions = this.$el.querySelector('.deliveryOptions');
                deliveryOptions.classList.toggle('open');
        },

        frequencyChange(e) {
            this.sellingPlan = e.target.value;
        },

        async getBundleIndex() {
            const res = await fetch('/cart.js');
            const cartData = await res.json();
          
            const indices = cartData.items
              .map(item => Number(item.properties?._dynamicBoxIndex))
              .filter(val => !isNaN(val));
          
            const largestIndex = indices.length > 0 ? Math.max(...indices) : -1;
            const bundleIndex = largestIndex + 1;
          
            return bundleIndex;
        },

        generateUniqueHash(length = 32) {
            const randomPart = Array.from(crypto.getRandomValues(new Uint8Array(length)))
              .map(b => b.toString(16).padStart(2, '0'))
              .join('');
            const timePart = Date.now().toString(16);
            return `${timePart}${randomPart}`;
        },

        async addToCart() {
            const sideCart = document.querySelector('side-cart');
            const items = [];
            const bundleIndex = await this.getBundleIndex();
            const bundleSessionId = this.generateUniqueHash();

            this.stackProducts.forEach(variantId => {
                items.push({
                    id: variantId,
                    quantity: 1,
                    selling_plan: this.sellingPlan ? Number(this.sellingPlan) : null,
                    properties: {
                        _attribution: 'Skio Dynamic Product Bundle',
                        _attribution_stack: 'Skio Stack',
                        _dynamicBoxIndex: bundleIndex,
                        _dynamicBoxId: this.dynamicBoxId,
                        _bundleSellingPlanId: Number(this.sellingPlan),
                        _stackParentId: this.stackParentId,
                        _stackParentTitle: this.stackParentTitle,
                        _is_stack: true,
                        _bundle_session_id: bundleSessionId,
                        _internal_id: this.dynamicBoxId,
                    }
                });
            });

            items.push({
                id: this.stackParentVariantId,
                selling_plan: this.sellingPlan ? Number(this.sellingPlan) : null,
                quantity: 1,
                properties: {
                    _attribution: 'Skio Dynamic Product Bundle',
                    _attribution_stack: 'Skio Stack',
                    // _dynamicBoxIndex: bundleIndex,
                    // _dynamicBoxId: '3b9cacb3-f64c-49a1-a141-4cb2af6c38b0',
                    _bundleSellingPlanId: Number(this.sellingPlan),
                    _stackParentId: this.stackParentId,
                    _stackParentTitle: this.stackParentTitle,
                    _is_stack: true,
                    _bundle_session_id: bundleSessionId,
                    _internal_id: this.dynamicBoxId,
                }
            })


            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: items,
                }),
            })
            .then(response => response.json())
            .then(data => {
                sideCart.renderCart();
                sideCart.openCart();
            })
            .catch(error => {
                console.error('Error:', error);
            });
        },

				
    }));
  };